var _circle, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurbhubPackagesDetailsBar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_403",
    "data-name": "Grupo 403",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_16",
    "data-name": "Elipse 16",
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#dedede"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_16",
    "data-name": "L\\xEDnea 16",
    y2: 250,
    transform: "translate(9 9.5)",
    fill: "none",
    stroke: "#dedede",
    strokeWidth: 2,
    "stroke-heigth": 100,
    strokeDasharray: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurbhubPackagesDetailsBar2);
export default __webpack_public_path__ + "static/media/curbhub_packages-details_bar_2.2533b92aad3e771b905eb5d673e5f52b.svg";
export { ForwardRef as ReactComponent };